<template>
	<div class="builds-wrapper">
		<h2>
			<span class="header-icon"></span>
			<span class="text">Build Pipeline</span>
		</h2>
		<div v-for="b in buildList" v-bind:key="b.buildId" class="build" v-bind:class="'build-' + getBuildClass(b.status)">
			<div class="build-icon">
				<i class="fas fa-clock" v-if="b.status === 1"></i>
				<i class="fas fa-cog fa-spin" v-else-if="b.status === 2"></i>
				<i class="fas fa-check-circle" v-else-if="b.status === 3"></i>
				<i class="fas fa-ban" v-else-if="b.status === 4"></i>
				<i class="fas fa-exclamation-triangle" v-else-if="b.status === 5"></i>
				<i class="fas fa-question-circle" v-else></i>
			</div>
			<div class="description">{{b.description}}</div>
			<div class="details">
				<i class="fas fa-code-branch fa-lg fa-fw"></i>
				{{b.sourceBranch}}
				-
				{{b.dateString}}
			</div>
		</div>
	</div>
</template>

<script>
	import Bugsnag from '@bugsnag/js'

	let azureBuilds = null;

	export default {
		name: 'DevBuilds',

		data() {
			return {
				buildList: []
			};
		},

		mounted() {
			console.log("Development builds module initiated");
			this.refreshAzureBuilds();
			azureBuilds = setInterval(this.refreshAzureBuilds, 10000);
		},
		
		destroyed() {
			console.log("Stopping Development builds module");
			clearInterval(azureBuilds);
		},
		
		methods: {

			getBuildClass(val) {
				switch (val) {
					case 1:
						return "queued";
					case 2:
						return "running";
					case 3:
						return "succeeded";
					case 4:
						return "cancelled";
					case 5:
						return "failed";
					default:
						return "unknown";
				}
			},

			refreshAzureBuilds() {
				let self = this;
				self.$http.get('/code/azure-builds', {}).then(response => {
					let data = response.body;
					self.buildList = data;
				}).catch(e => {
					Bugsnag.notify(new Error(e.url), function (event) {
						event.addMetadata('httpResponse', e);
					});
					console.error(e);
				});
			}
		}
	}
</script>

<style lang="less" scoped>
	@import '../../less/_variables.less';

	@bg-build-queued: #666;
	@bg-build-running: #3683FF;
	@bg-build-succeeded: #7FA750;
	@bg-build-failed: #B24434;
	@bg-build-cancelled: #B5871D;
	@bg-build-unknown: #333;

	.builds-wrapper {
		padding: 2% 2% 1%;
		width: 33%;
		height: 60%;
	}

	.build {
		border-radius: @border-radius;
		margin-top: 0.3em;
		padding: 0.6em 1em 0.6em 15%;
		position: relative;
	}

	.build-icon {
		position: absolute;
		display: flex;
		justify-content: center;
		align-items: center;
		left: 0;
		top: 0;
		width: 15%;
		height: 100%;
		font-size: 2.5em;
	}

	.build-queued {
		background-color: @bg-build-queued;
	}

	.build-running {
		background-color: @bg-build-running;
	}

	.build-succeeded {
		background-color: @bg-build-succeeded;
	}

	.build-failed {
		background-color: @bg-build-failed;
	}

	.build-cancelled {
		background-color: @bg-build-cancelled;
	}

	.build-unknown {
		background-color: @bg-build-cancelled;
	}

	.description {
		font-weight: 700;
		font-size: 1.2em;
		white-space: nowrap;
		overflow: hidden;
		text-overflow: ellipsis;
	}

	.metrics {
		line-height: 1.4em;
		padding-top: 0.2em;
	}

	.metric-item {
		display: inline-block;
		padding-left: 0.3em;
	}

	.details {
		line-height: 1.4em;
		padding-top: 0.2em;
		opacity: 0.6;
		white-space: nowrap;
		text-overflow: ellipsis;
		overflow: hidden;
	}

	h2 {
		display: flex;
		justify-content: flex-start;
		align-items: center;
		margin: 0;
		font-size: 2em;
		line-height: 1em;

		span.header-icon {
			background-size: contain;
			background-position: center center;
			background-repeat: no-repeat;
			width: 1.7em;
			height: 1.7em;
			background-image: url(images/builds.svg);
		}

		span.text {
			text-transform: uppercase;
			padding-left: 0.5em;
		}
	}
</style>


// WEBPACK FOOTER //
// dev-builds.vue?3eb4133e